
<div class="card">

  <div class="row" style="padding: 15px 10px 10px 15px;">
    <div class="col-12 text-center"  style="padding-bottom:25px; padding-top:15px;">
      <h4><b>Descadastramento da Campanha Nota Premiada Bahia realizado com sucesso</b></h4>
    </div>
    <div class="col-12 text-justify">
      <b>{{ consumidor.nome | uppercase }} ({{ cpfFormat | cpfMask }})</b>,
      mediante sua solicitação realizada em <b>{{ consumidor.dataExclusao | date:'dd/MM/yyyy HH:mm' }}</b>,
      o seu cadastro na Campanha Nota Premiada Bahia foi desativado.<br>
      Caso você queira voltar a participar da Campanha, basta efetuar o seu cadastro novamente.
      <br><br>
      Obrigado,
      <br>
      Equipe da Campanha NPB
    </div>
  </div>
</div>
<br>
<div class="row">
  <div class="col-12">
    <button class="btn btn-bluelight" routerLink="/consumidor"
    data-toggle="tooltip" data-placement="top" title="Voltar">
      Voltar
    </button>
  </div>
</div>
<!-- card -->



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-descadastrar/consumidor-descadastrar.component.html